import { styled } from 'buttered';

export let Center = styled('section')`
  width: fit-content;
  max-width: calc(100vw - 30px);
  margin: 0px auto;
`;
